// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import VueMeta from 'vue-meta'
import wxlogin from 'vue-wxlogin';
import wx from 'weixin-js-sdk';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import MintUI from 'mint-ui';
import 'mint-ui/lib/style.css'
import  './assets/svgs/index';
import store from './components/store/store'
// import Buefy from 'buefy'
// import 'buefy/dist/buefy.css'
import { fetchGet, fetchPost,fetchPut,fetchDelete,fetchGetA,fetchGetB} from './common/js/axiosConfig';
// import {wxlg} from 'http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
Vue.prototype.$get = fetchGet
Vue.prototype.$geta = fetchGetA
Vue.prototype.$getb = fetchGetB
Vue.prototype.$post = fetchPost
Vue.prototype.$put = fetchPut
Vue.prototype.$delete = fetchDelete
Vue.config.productionTip = false
Vue.prototype.wx = wx//
// Vue.prototype.wxlg = wxlg
// import signalr from './common/js/signalR'
// Vue.use(signalr)
// Vue.component(Checklist.name, Checklist);
// Vue.use(ElementUI,VueMeta,VueAwesomeSwiper,MintUI,Buefy)
Vue.component('my-component', {
  components: {wxlogin}
});
/*自定义方法*/
import filters from '@/utils/filters'
Vue.use(filters); //全局过滤器

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
Vue.use(ElementUI,VueAwesomeSwiper)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js